import PropTypes from 'prop-types';

export const GenericSuccessProps = {
  locales: PropTypes.object,
  buttonsProps: PropTypes.shape({
    primaryButton: PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
    }),
    secondaryButton: PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
    }),
  }),
};
